import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { BookingSummaryCard} from "../../../Models";
import { getValueByLang } from "../../../Utils";
import dayjs from 'dayjs';
import RoomTypeSelectionComponent from "./RoomTypeSelectionComponent";

interface Attrs {
    isDesktop?:boolean;
    bookingSummaryCard: BookingSummaryCard;
    messageProvider: MessageProvider;
    collapsible:boolean;
}

export default function BookingSessionSummaryComponent(): m.Component<Attrs> {
    let isExpanded = false;
    let nationality = "";

    return {
        oninit(vnode) {
            isExpanded = !vnode.attrs.collapsible;
            if(vnode.attrs.bookingSummaryCard.guest != null) {
                var getCountryNames = new Intl.DisplayNames(['en'], {type: 'region'});
                nationality = getCountryNames.of(vnode.attrs.bookingSummaryCard.guest.countryCode) || ""
            }
        },

        view(vnode) {
            const {isDesktop, bookingSummaryCard, messageProvider, collapsible} = vnode.attrs;
            let lang = messageProvider.getCurrentLang();

            let numberOfNights = dayjs(bookingSummaryCard.checkOutDate).diff(bookingSummaryCard.checkInDate, 'day'); 
            
            return m("div.card shadow ", {
                    class: (isDesktop)? "rounded-16": "rounded-bottom-16",
                    onclick: function(event:Event) {
                        event.preventDefault();
                        if(collapsible) {
                            isExpanded = !isExpanded;
                            console.log("clicked event on chevron: expanded", isExpanded);
                        }
                    }
                },
                m("div.card-body", [
                    m("div.d-flex", [
                        isDesktop?
                        m("div.w-100", { class: "" }, [
                            m("strong.text-dark", getValueByLang(bookingSummaryCard.hotelName, lang)),                    
                            m("div.row.mt-3", 
                                m("div.col-5", m("label", "Check-in Date :")),
                                m("div.col-7", m("label", [
                                    m("b", dayjs(bookingSummaryCard.checkInDate).format("MMM DD, dddd") ),
                                ]))
                            ),
                            m("div.row", 
                                m("div.col-5", m("label", "Check-out Date :")),
                                m("div.col-7", m("label", m("b", dayjs(bookingSummaryCard.checkOutDate).format("MMM DD, dddd"))))
                            ),
                            m("div.mt-2", [
                                m("label", m("b", numberOfNights + " " + ((numberOfNights == 1)? messageProvider.get("night"): (messageProvider.get("nights"))))),
                                m("span", m("b", ((messageProvider.getCurrentLang() == "en")?", ": "၊ "))),

                                (bookingSummaryCard.numberOfRooms == 1)? 
                                    m("label", m("b",bookingSummaryCard.numberOfRooms + " " + messageProvider.get("room"))) 
                                :   m("label", m("b",bookingSummaryCard.numberOfRooms + " " + messageProvider.get("rooms"))),
                                m("span", m("b", ((messageProvider.getCurrentLang() == "en")?", ": "၊ "))),
                                m("label",m("b",(bookingSummaryCard.guestType == 'LOCAL'? 
                                    messageProvider.get("local_guests") : messageProvider.get("foreigner_guests"))))
                            ]),
                            
                        ])
                        :
                        m("div.w-100", { class: "" }, [
                            m("div.font-weight-bold", getValueByLang(bookingSummaryCard.hotelName, lang)),                    
                            m("div", [
                                m("small", dayjs(bookingSummaryCard.checkInDate).format("MMM DD")),
                                m("span", " - "),
                                m("small", dayjs(bookingSummaryCard.checkOutDate).format("MMM DD")),
                                m("small.pl-1", "( " + numberOfNights + " " + ((numberOfNights == 1)? messageProvider.get("night"): (messageProvider.get("nights"))) + " )" + ((messageProvider.getCurrentLang() == "en")?", ": "၊ ")),
                                m("small", bookingSummaryCard.numberOfRooms + " " + ((bookingSummaryCard.numberOfRooms == 1)? messageProvider.get("room"): messageProvider.get("rooms")) + ((messageProvider.getCurrentLang() == "en")?", ": "၊ ")),
                                m("small", bookingSummaryCard.guestType == 'LOCAL'? 
                                    messageProvider.get("local") : messageProvider.get("foreigner"))
                            ])
                        ]),
                        (collapsible)?
                        m("div.flex-shrink-1 text-primary", [
                            (isExpanded) ?
                            m("i.bi bi-chevron-up") :
                            m("i.bi bi-chevron-down")
                        ]):null                      
                    ]),

                    (isExpanded)?
                    m("div.mt-3", {}, [
                        m("div.pb-2 font-weight-bold text-muted", messageProvider.get("room_detail")),

                        bookingSummaryCard.roomTypeSelections.map((roomTypeSelection, index) => {
                            return [
                                m(RoomTypeSelectionComponent, {
                                    messageProvider: messageProvider,
                                    roomTypeSelection: roomTypeSelection,
                                }),
                                (index < bookingSummaryCard.roomTypeSelections.length - 1)?
                                m("hr"):null
                            ];
                        }),

                        (bookingSummaryCard.guest != null)?
                        [
                            m("div.mb-2 mt-3 font-weight-bold text-muted", messageProvider.get("guest_info")),
                            m("div.row py-1", [
                                m("div.col-4", m("small", messageProvider.get("guest_name"))),
                                m("div.col-8", m("small", bookingSummaryCard.guest.name))
                            ]),
                            m("div.row py-1", [
                                m("div.col-4", m("small", messageProvider.get("guest_phone_number"))),
                                m("div.col-8", m("small", bookingSummaryCard.guest.cellPhoneNumber))
                            ]),
                            m("div.row py-1", [
                                m("div.col-4", m("small", messageProvider.get("nationality"))),
                                m("div.col-8", m("small", nationality))
                            ]),
                            (bookingSummaryCard.guest.emailAddress != null)?
                            m("div.row py-1", [
                                m("div.col-4", m("small", messageProvider.get("email"))),
                                m("div.col-8", m("small", bookingSummaryCard.guest.emailAddress))
                            ]):null
                        ]:null
                    ]):null
                ])            
            )
        }
    }
}